import { FC } from 'react'
import cx from 'classnames'

import * as SC from './styled'

type Item = {
  label: string
  value?: string
  values?: Array<string>
}

export type AdsDetailsProps = {
  className?: string
  items: Array<Item>
  withColumn?: boolean
}

const AdsDetails: FC<AdsDetailsProps> = ({
  className,
  items,
  withColumn = true,
}) => {
  return (
    <SC.AdsDetails
      className={cx('AdsDetails', className)}
      $withColumn={withColumn}
    >
      {items.map((item, index) => (
        <SC.AdsDetailsItem key={index} $withColumn={withColumn}>
          <SC.Label>{item.label}</SC.Label>
          <SC.ValueContainer>
            {item.value && <SC.Value>{item.value}</SC.Value>}
            {item.values && <SC.Value>{item.values.join(' - ')}</SC.Value>}
          </SC.ValueContainer>
        </SC.AdsDetailsItem>
      ))}
    </SC.AdsDetails>
  )
}

export default AdsDetails
